import * as types from "~/store/filter/types";

const initialState = {
  checkFilterPopup: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_FILTER_BY_STEP: {
      return {
        ...state,
        checkFilterPopup: action.payload
      };
    }
    case types.RESET_FILTER_BY_STEP: {
      return {
        ...state,
        checkFilterPopup: ""
      };
    }
    case types.SET_GUARANTEE_COMPANY: {
      return {
        ...state,
        guaranteeCompanys: action.payload
      };
    }
    default:
      return state;
  }
};
